import React from 'react';
import './WideOverlayContainer.css';

interface Props {
  id: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const WideOverlayContainer: React.FC<Props> = (props: Props) => {
  const { id, style, children } = props;

  return (
    <div
      id={id}
      className="wide-overlay-container pos-a column h100"
      style={{
        bottom: '0px',
        right: '0px',
        height: 'calc(100vh - 48px)',
        overflow: 'hidden',
        backgroundColor: 'var(--white-2)',
        ...style,
      }}
    >
      {children}
    </div>
  );
};

WideOverlayContainer.defaultProps = {
  style: {},
};

export default WideOverlayContainer;
